import { useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const photoUrl = (p) => (p ? (p.startsWith("http") ? p : `${BACKEND}${p}`) : "");

export function PhotoUpload({ value, onChange, fallback = "?", size = "w-24 h-24", rounded = "rounded-3xl", testId = "photo-upload" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Foto diunggah");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <button type="button" data-testid={testId} onClick={() => ref.current?.click()} className={`relative ${size} ${rounded} overflow-hidden bg-gradient-to-br from-orange-400 to-amber-500 text-white font-display font-bold text-3xl flex items-center justify-center shrink-0 group`}>
      {value ? <img src={photoUrl(value)} alt="foto" className="w-full h-full object-cover" /> : fallback}
      <span className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
        {busy ? <Loader2 className="w-6 h-6 animate-spin" /> : <Camera className="w-6 h-6" />}
      </span>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} />
    </button>
  );
}

export function Avatar({ src, name = "?", size = "w-12 h-12", rounded = "rounded-2xl", text = "text-lg" }) {
  return (
    <div className={`${size} ${rounded} overflow-hidden bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center text-white font-display font-bold ${text} shrink-0`}>
      {src ? <img src={photoUrl(src)} alt={name} className="w-full h-full object-cover" /> : name.charAt(0)}
    </div>
  );
}
